<template>
  <div class="questionWrapper-container">
    <!-- Ввод мессенджера -->
    <div
      v-if="!showMessengerOptions"
      class="telegram-form"
    >
      <label
        for="telegram-input"
        class="messenger-input"
      >
        {{ selectedMessenger }}
      </label>
      <input
        id="telegram-input"
        v-model="messengerContact"
        class="telegram-input"
      />
      <div
        class="other-messenger"
        @click="toggleMessengerOptions"
      >
        {{ $t('common.otherMessenger') }}
      </div>
      <div class="quiz-action-buttons-container d-flex">
        <v-btn
          class="download-btn-anty-browser"
          color="primary"
          block
          @click="handleDownloadBrowser"
        >
          <d-mark-icon class="download-btn-anty-browser-mark-icon" />
          <span class="download-btn-anty-browser-text">{{ $t('common.downloadAnty') }}</span>
        </v-btn>
        <v-btn
          class="personal-account-btn"
          elevation="0"
          block
          @click="handleClose"
        >
          <span class="personal-account-btn-text">
            {{ $t('common.personalArea') }}
          </span>
        </v-btn>
      </div>
    </div>

    <!-- Выбор мессенджера -->
    <div v-else class="messenger-list">
      <div class="choose-messenger">
        {{ $t('quiz.new.step5.subtitle') }}
      </div>
      <div class="messenger-options">
        <div
          v-for="messenger in messengers"
          :key="messenger.name"
          class="messenger-item"
          @click="selectMessenger(messenger.name)"
        >
          <img
            :src="messenger.icon"
            :alt="messenger.name"
            class="messenger-icon"
          />
          <span class="messenger-item-name">{{ messenger.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MESSENGERS, TELEGRAM_MESSENGER } from '@/constants/quiz'
import DMarkIcon from '@/assets/quiz/dMarkLogo.svg?inline'

export default {
  name: 'MessengerForm',
  components: { DMarkIcon },

  computed: {
    ...mapGetters({
      profile: 'main/profile',
    }),
  },

  data() {
    return {
      messengerContact: '',
      selectedMessenger: TELEGRAM_MESSENGER,
      showMessengerOptions: false,
      messengers: MESSENGERS,
    }
  },

  mounted() {
    this.messengerContact = this.profile?.telegram || ''
  },

  methods: {
    handleClose () {
      this.$emit('close', this.messengerContact, this.selectedMessenger);
    },

    handleDownloadBrowser () {
      this.$store.dispatch('main/setUserShowAccountPanel', false)
      this.$emit('handleDownloadBrowser', this.messengerContact, this.selectedMessenger);
    },

    selectMessenger(messengerName) {
      this.messengerContact = ""
      this.selectedMessenger = messengerName;
      this.showMessengerOptions = false;
    },

    toggleMessengerOptions() {
      this.showMessengerOptions = !this.showMessengerOptions;
    },
  }
}

</script>

<style lang="scss" scoped>
.questionWrapper-container .telegram-form .quiz-action-buttons-container .personal-account-btn{
  max-width: 190px;
  min-width: unset!important;
  background-color: transparent;
  border-radius: 8px;
}

.telegram-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}

.download-btn-anty-browser-mark-icon {
  fill: white;
}

.telegram-form .quiz-action-buttons-container .personal-account-btn,
.telegram-form .quiz-action-buttons-container .download-btn-anty-browser {
  height: 48px;
  padding: 16px 32px;
  box-shadow: none;
  letter-spacing: normal;
}

.messenger-input {
  color: var(--v-input-label-default-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.telegram-input {
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 6px;
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--v-input-border-default-base);
  background: var(--v-input-background-default-base);
  outline: none;
}

.other-messenger {
  color: var(--v-link-primary-text-default-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 34px;
  cursor: pointer;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
}

.quiz-action-buttons-container {
  max-width: 50%;
  gap: 12px;
}

.download-btn-anty-browser {
  width: fit-content;
  height: 48px;
  border-radius: 8px;
  padding: 12px 32px;
}

.download-btn-anty-browser-text {
  text-transform: none;
  color: var(--v-button-primary-foreground-default-base);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-left: 8px;
}

.personal-account-btn-text {
  color: var(--v-text-secondary-base);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-transform: none;
}

.messenger-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
}

.choose-messenger {
  color: var(--v-text-primary-base);
  font-family: Roboto, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.messenger-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.messenger-item {
  display: flex;
  padding: 20px 28px;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  align-self: stretch;
  border-radius: 16px;
  background: var(--v-background-primary-default-base);
  box-shadow: 0 24px 30px -24px rgba(208, 206, 217, 0.40), 0px 0px 0px 1px rgba(61, 59, 53, 0.08), 0px 2px 6px 0px rgba(61, 59, 53, 0.06);
}

.messenger-item:hover {
  background: var(--v-background-primary-hover-base);
}

.messenger-item-name {
  color: var(--v-text-primary-base);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

@media (max-width: 1200px) {
  .questionWrapper-container .telegram-form .quiz-action-buttons-container .personal-account-btn{
    max-width: 100%;
  }

  .quiz-action-buttons-container {
    width: 100%;
    max-width: 100%;
    flex-direction: column;
  }

  .download-btn-anty-browser {
    width: 100%;
  }
}
</style>
